import { type SearchData, SearchResultSchema } from "front-search-schema/algolia";
import { array, object, safeParse, string } from "valibot";
import { algoliaClient } from "./algoliaClient";

const SuggestionsSchema = object({
  hits: array(object({ query: string() })),
});

type Input = {
  q?: string;
  filter: Array<Array<string>>;
};
export const basicSearchTravelClient = async ({ q = "", filter }: Input): Promise<SearchData> => {
  try {
    const splits: string[] = [];
    for (const element of filter) {
      if (element.length > 0) {
        splits.push(`(${element.join(" OR ")})`);
      }
    }

    const query = splits.join(" AND ");

    const response = await algoliaClient.search({
      requests: [
        {
          indexName: "date_asc",
          query: q,
          facets: ["themes", "destinations", "speakers", "speakerIds", "startMonths", "budgets", "rythme", "durations"],
          page: 0,
          hitsPerPage: 20,
          filters: query,
          analyticsTags: [],
          analytics: false,
          clickAnalytics: false,
          highlightPreTag: "<span>",
          highlightPostTag: "</span>",
          attributesToHighlight: ["title"],
        },
        {
          indexName: "search_travels_query_suggestions",
          query: q,
        },
      ],
    });

    const results = response.results[0];
    const suggestionResults = response.results[1];

    const result = safeParse(SearchResultSchema, results);

    if (result.success) {
      const resultSuggestions = safeParse(SuggestionsSchema, suggestionResults);

      return {
        queryId: result.output.queryID,
        travels: result.output.hits,
        fitTravels: [],
        totalTravels: result.output.nbHits,
        themes: Object.entries(result.output.facets.themes || {}).map(([key, count]) => ({ key, count })),
        destinations: Object.entries(result.output.facets.destinations || {}).map(([key, count]) => ({
          key,
          count,
        })),
        speakers: Object.entries(result.output.facets.speakers || {}).map(([key, count]) => ({ key, count })),
        speakerIds: Object.entries(result.output.facets.speakerIds || {}).map(([key, count]) => ({
          key: Number.parseInt(key),
          count,
        })),
        startMonths: Object.entries(result.output.facets.startMonths || {}).map(([key, count]) => ({
          key,
          count,
        })),
        budgets: Object.entries(result.output.facets.budgets || {}).map(([key, count]) => ({ key, count })),
        rythmes: Object.entries(result.output.facets.rythme || {}).map(([key, count]) => ({ key, count })),
        durations: Object.entries(result.output.facets.durations || {}).map(([key, count]) => ({ key, count })),
        suggestions: resultSuggestions.success ? resultSuggestions.output.hits.map((hit) => hit.query) : [],
      };
    }
  } catch (error) {
    console.log(error);
  }

  return {
    travels: [],
    fitTravels: [],
    totalTravels: 0,
    themes: [],
    destinations: [],
    speakers: [],
    speakerIds: [],
    startMonths: [],
    budgets: [],
    rythmes: [],
    durations: [],
    suggestions: [],
    queryId: undefined,
  };
};
